import React from 'react';
import { Modal, Box, IconButton, useTheme, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ImageModal = ({ open, onClose, image }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 2,
          width: isMobile ? '350px' : '500px',
          maxHeight: '90vh',
          overflowY: 'auto',
          borderRadius: 1
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'grey.500'
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <Box
          component="img"
          src={image}
          alt="Modal content"
          sx={{
            width: '100%',
            height: 'auto',
            display: 'block',
            mt: 2
          }}
        />
      </Box>
    </Modal>
  );
};

export default ImageModal;